import { PLACEHOLDER_BUTTON__bar } from './PLACEHOLDER_BUTTON__bar';

export function PLACEHOLDER_BUTTON__BarGeneration() {
  return <PLACEHOLDER_BUTTON__bar class_name_button="size-4 min-w-8" class_name_icon="size-2" />;
}
